import api from './api';

export const placesService = {
  async autocomplete(input, types = []) {
    const params = new URLSearchParams();
    params.set('input', input);
    if (types.length > 0) {
      params.set('types', types.join('|'));
    }
    const response = await api.get(`/api/places/autocomplete?${params.toString()}`);
    return response.data?.predictions || [];
  },

  async getDetails(placeId) {
    const response = await api.get(`/api/places/details?place_id=${encodeURIComponent(placeId)}`);
    return response.data;
  }
};
